/* Libs */
import styled, { css } from 'styled-components';
import { DEVICES } from '_constants';
import { CLOSE_MODAL_ICON } from 'assets/icons';

/* Styles */
export const Title = styled.div`
  flex-grow: 1;
  font-size: 20px;
  color: var(--modal-text);
  text-align: left;
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px 40px 0;
`;

export const CancelIconWrapper = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--dark);
  background: transparent url(${CLOSE_MODAL_ICON}) no-repeat center center;
  padding: 0;
  border: none;

  /* New design: CLOSE_MODAL_ICON is an SVG file with fill="#0D0D0D" baked in and loaded as a
     background image, so nothing on this element can recolour it. Drop it and draw the ✕ from two
     bars in currentColor, which then takes the modal's forest text colour.

     Note html[...] and not :root[...] — stylis auto-prefixes the parent onto any selector that
     starts with a pseudo-class, so ":root[data-new-ui='true'] &" compiles to
     ".generatedClass:root[...] .sc-id", which can never match. An element name is left alone. */
  html[data-new-ui='true'] & {
    top: 14px;
    right: 14px;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: transparent;
    color: var(--modal-text);
    transition: background 0.15s ease;

    &:hover {
      background: var(--lite-grey);
    }

    /* Centred explicitly rather than relying on the flex static position of an abspos child. */
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 17px;
      height: 2px;
      margin: -1px 0 0 -8.5px;
      border-radius: 1px;
      background: currentColor;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }
`;

export const OverallModalWrapper = styled.div`
  position: fixed;
  z-index: 9000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--dark30);
`;

export const Content = styled.div`
  position: relative;
  padding: ${({ withoutPadding }) => (withoutPadding ? '0' : '45px 38px 10px')};
  font-size: 16px;
  line-height: 1.25;
  color: var(--modal-text);
  box-sizing: border-box;

  @media ${DEVICES.tablet} {
    padding: ${({ withoutPadding }) => (withoutPadding ? '0' : '45px 15px 0')};
  }
`;

export const Modal = styled.div`
  position: relative;
  z-index: 100;
  /* TODO: think about modal content overflow and position */
  /* transform: translateY(-50%); */
  width: ${({ autoWidth }) => (autoWidth ? 'auto' : '630px')};
  max-height: calc(100vh - 40px);
  /* TODO: think about modal content overflow and position */
  padding: ${({ withoutPadding }) => (withoutPadding ? '0' : '0 0 32px')};
  background-color: var(--white);
  /* 0 / none with the flag off, so the legacy modal is untouched — see base.scss. */
  border-radius: var(--modal-radius);
  box-shadow: var(--modal-shadow);
  box-sizing: border-box;
  background-repeat: no-repeat;
  overflow-y: ${({ preventDesktopOverflow }) => (preventDesktopOverflow ? 'visible' : 'auto')};

  .add_retailers_modal {
    padding: 5px;
    padding-right: 0;
  }

  @media ${DEVICES.tablet} {
    max-width: 100vw;
    width: auto;
    height: ${({ autoHeight }) => (autoHeight ? 'auto' : 'fit-content')};
    max-height: 100%;
    overflow-y: ${({ hideOverflow }) => (hideOverflow ? 'unset' : 'auto')};
  }

    ${({ isFullScreen }) =>
      isFullScreen &&
      css`
        width: 100vw;
        height: 100vh;
        max-height: 100%;
        padding: 0;
        margin: 0;
        overflow-y: visible;
        /* Edge to edge — a radius here would just frame the overlay. */
        border-radius: 0;

        ${Content} {
          padding: 0;
          height: 100%;
        }
      `}
  }

  @media ${DEVICES.mobileXL} {
    .BaseSelect {
      &__control {
        border-radius: 0;
        width: 100%;
      }

      &__indicator-separator {
        display: none;
      }

      &__menu {
        border-radius: 0;

        &-list {
          max-height: 120px;
          width: 100%;
        }
      }
    }
`;
